import { ActionContext } from 'vuex'
import { IRootState } from './state'
import axios from 'axios'
import api, { ApiResponse } from '@/api'
import { Types } from './mutations'
import { AUTH_ACCESS_TOKEN_KEY } from '@/constants'

export interface OvaBalancesV1 {
  default: number
  refund: number
  interest: number
}

export interface IRootActions {
  fetchBeneficiaryCounts(
    context: ActionContext<IRootState, IRootState>
  ): Promise<ApiResponse>

  fetchOvaBalancesV1(
    context: ActionContext<IRootState, IRootState>,
    organizationId: string
  ): Promise<OvaBalancesV1>

  checkSfdAccessToProdij(
    context: ActionContext<IRootState, IRootState>
  ): Promise<boolean>
}

export const RootActions: IRootActions = {
  fetchBeneficiaryCounts({ commit }) {
    return api.countBeneficiaries().then((response: ApiResponse) => {
      if (response.isSuccessful) {
        commit(Types.ADD_BENEFICIARY_COUNTS, response.data)
      }

      return response
    })
  },

  /**
   * Soldes OVA V1 (décaissement / remboursement / intérêts) d'une organisation.
   * Même source que les pages finances de la V1 : `/organizations/:id/stats`
   * interroge Kkiapay en temps réel et ne retombe sur les soldes stockés
   * qu'en cas d'échec. `kkiapayaccounts.balance` (lu par l'ancien
   * `/kkiapay-accounts/get-account-balances`) n'est pas tenu à jour.
   */
  async fetchOvaBalancesV1(_context, organizationId) {
    const accessToken = sessionStorage.getItem(AUTH_ACCESS_TOKEN_KEY)
    const url =
      process.env.VUE_APP_V1_API_BASE_URL +
      `/organizations/${organizationId}/stats`
    const { data } = await axios.request({
      url,
      headers: {
        Authorization: 'Bearer ' + accessToken
      },
      params: {
        referer: 'v2'
      }
    })
    // Un compte absent est renvoyé sous la forme `0` au lieu d'un objet.
    const total = (stats: any): number => Number(stats?.all) || 0

    return {
      default: total(data?.disbursement),
      refund: total(data?.refund),
      interest: total(data?.interest)
    }
  },

  async checkSfdAccessToProdij(): Promise<boolean> {
    console.log('process.env.:', process.env)
    const accessToken = sessionStorage.getItem(AUTH_ACCESS_TOKEN_KEY)
    const url = process.env.VUE_APP_PRODIJ_API_URL + '/sfd/check-access/sfd'

    const result = await axios.request({
      url,
      headers: {
        Authorization: 'Bearer ' + accessToken
      },
      params: {
        referer: 'v2'
      }
    })

    return result.data
  }
}
